import React from "react"

const CartExtension = ({ item, cartProducts = [], handleRemoveProductClick = null }) => {
  return (
    <>
      <div className="col-11 offset-md-1 cart__table-extensions">
        <b>Rozszerzenia:</b>
      </div>
      <div className="col-12 cart__table-extension">
        {item?.extensions?.map((single, ix) => (
          <div className="row" key={ix}>
            <div className="col-md-6 offset-md-1">
              <small className="cart__table-mobile-label">Nazwa</small>
              {single.name}
            </div>
            <div className="col-md-2">
              <small className="cart__table-mobile-label">Liczba sztuk</small>
              {single.qty} szt.
            </div>
            <div className="col-md-2">
              <small className="cart__table-mobile-label">Kwota (brutto)</small>
              {single.totalPrice}
            </div>
            {(cartProducts && handleRemoveProductClick) && (
              <div className="col-md-1 text-center">
                <button
                  className="cart__table-remove"
                  onClick={event => {
                    handleRemoveProductClick(
                      event,
                      single.cartKey,
                      cartProducts
                    )
                  }}
                >
                  Remove
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  )
}

export default CartExtension
